import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import SeoContentSection from './components/SeoContentSection';
import TrendingSection from './components/TrendingSection';
import ArticleGrid from './components/ArticleGrid';
import CtaSection from './components/CtaSection';
import TestimonialSection from './components/TestimonialSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://pandabuy.motorcycles';

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  'name': 'PandabuySpreadsheet - Smart Product Comparison & Data-Driven Shopping Hub',
  'description': 'Make better buying decisions using structured product spreadsheets, data-driven comparisons, and real-world cost analysis. Explore 14 product categories with detailed comparison tables and shopping guides.',
  'url': siteUrl,
  'dateModified': '2026-06-29',
  'about': {
    '@type': 'Organization',
    'name': 'PandabuySpreadsheet',
    'url': siteUrl,
    'logo': 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={webPageSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <TrendingSection />
        <ArticleGrid />
        <SeoContentSection />
        <CtaSection />
        <TestimonialSection />
      </main>
      <Footer />
    </div>
  );
}